import { render, staticRenderFns } from "./InvestorItem.vue?vue&type=template&id=766329da&scoped=true"
import script from "./InvestorItem.vue?vue&type=script&lang=ts"
export * from "./InvestorItem.vue?vue&type=script&lang=ts"
import style0 from "./InvestorItem.vue?vue&type=style&index=0&id=766329da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766329da",
  null
  
)

export default component.exports